import { type EditionResponse, getEditionById } from '@api/editions-api';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';

interface UseEditionResult {
  edition: EditionResponse | null;
  isLoading: boolean;
  error: string | null;
  refetch: () => void;
}

export function useEdition(id: string | undefined): UseEditionResult {
  const queryClient = useQueryClient();

  const { data, isLoading, error } = useQuery({
    queryKey: ['edition', id],
    queryFn: () => getEditionById(id!),
    enabled: !!id,
  });

  const refetch = useCallback(() => {
    void queryClient.invalidateQueries({ queryKey: ['edition', id] });
  }, [queryClient, id]);

  return {
    edition: data ?? null,
    isLoading: !!id && isLoading,
    error: error ? (error instanceof Error ? error.message : 'Failed to load edition') : null,
    refetch,
  };
}
